"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants.js");

var _common = require("./common.js");

var _frameComponent = _interopRequireDefault(require("./frame-component.js"));

var _cookiePopup = _interopRequireDefault(require("./cookie-popup.js"));

var _cookiePopupThemes = _interopRequireDefault(require("./cookie-popup-themes.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SnapchatFooter =
/*#__PURE__*/
function (_FrameComponent) {
  _inherits(SnapchatFooter, _FrameComponent);

  function SnapchatFooter(props) {
    var _this;

    _classCallCheck(this, SnapchatFooter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SnapchatFooter).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getFontContrast", function (hexcolor) {
      var color = hexcolor; // If a leading # is provided, remove it

      if (color.slice(0, 1) === '#') {
        color = color.slice(1);
      } // If a three-character hexcode, make six-character


      if (color.length === 3) {
        color = color.split('').map(function (hex) {
          return hex + hex;
        }).join('');
      } // Convert to RGB value


      var r = parseInt(color.substr(0, 2), 16);
      var g = parseInt(color.substr(2, 2), 16);
      var b = parseInt(color.substr(4, 2), 16); // Get YIQ ratio

      var yiq = (r * 299 + g * 587 + b * 114) / 1000; // Check contrast

      return {
        titleFontColor: yiq >= 128 ? 'rgba(0,0,0,.87)' : 'rgba(255,255,255,.87)',
        linkFontColor: yiq >= 128 ? 'rgba(0,0,0,.87)' : 'rgba(255,255,255,.87)',
        linkFontColorHover: yiq >= 128 ? 'black' : 'white'
      };
    });

    _this.localeSelected = _this.localeSelected.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SnapchatFooter, [{
    key: "callInitExpandingColumns",
    value: function callInitExpandingColumns(footerContainerElement) {
      (0, _common.initExpandingFooterColumns)(footerContainerElement);
    }
  }, {
    key: "localeSelected",
    value: function localeSelected(event) {
      var newLocale = event.target.value;
      (0, _common.setLocaleCookie)(newLocale, this.props.cookieDomain);

      if (this.props.onLocaleSelected) {
        this.props.onLocaleSelected(newLocale);
      }
    }
  }, {
    key: "renderColumnHeaderCaret",
    value: function renderColumnHeaderCaret(color) {
      // TODO: move this to sass once clients are able to consume it
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-column-expand-caret"
        },
        /*#__PURE__*/
        _react["default"].createElement("svg", {
          width: "15",
          height: "20",
          fill: color
        },
        /*#__PURE__*/
        _react["default"].createElement("g", null,
        /*#__PURE__*/
        _react["default"].createElement("rect", {
          stroke: color,
          transform: "rotate(45 0,0)",
          rx: "1",
          id: "1",
          height: "1.5",
          width: "10",
          y: "-2",
          x: "5",
          strokeWidth: "1"
        }),
        /*#__PURE__*/
        _react["default"].createElement("rect", {
          stroke: color,
          transform: "rotate(-45 0,0)",
          rx: "1",
          id: "2",
          height: "1.5",
          width: "10",
          y: "13.5",
          x: "-8",
          strokeWidth: "1"
        }))))
      );
    }
  }, {
    key: "render",
    value: function render() {
      // Defining CSS is not encouraged in React component, but pseudo-selectors and media queries
      // are good platform-agnostic way of expressing footer behavior in this case.
      // TODO: evaluate if it makes sense to move CSS to extra file to be consumed by clients explicitly
      var _this$getFontContrast = this.getFontContrast(this.props.backgroundColor),
          titleFontColor = _this$getFontContrast.titleFontColor,
          linkFontColor = _this$getFontContrast.linkFontColor,
          linkFontColorHover = _this$getFontContrast.linkFontColorHover;

      var css = "\n      .footer-container,\n      .footer-bottom-bar {\n        width: 92.3%;\n        max-width: 1070px;\n        margin: auto;\n      }\n\n      .footer-container {\n        box-sizing: content-box;\n        position: relative;\n        padding: 30px 0 30px;\n        min-height: 195px;\n      }\n\n      .footer-container .footer-column {\n        position: relative;\n        box-sizing: border-box;\n        float: left;\n        width: 25%;\n        padding-inline-end: 6.25%;\n      }\n\n      [dir=\"rtl\"] .footer-container .footer-column {\n        float: right;\n      }\n\n      .footer-container .footer-column .footer-column-header {\n        box-sizing: content-box;\n        color: ".concat(titleFontColor, ";\n        line-height: 23px;\n        font-weight: 500;\n      }\n\n      .footer-container .footer-column .footer-column-expand-caret {\n        display: none;\n      }\n\n      .footer-container .footer-column a {\n        display: table;\n        color: ").concat(linkFontColor, ";\n        text-decoration: none;\n        line-height: 17px;\n        margin-top: 6px;\n      }\n      .footer-container .footer-column a:hover {\n        color: ").concat(linkFontColorHover, ";\n      }\n\n      .footer-container .langue-selection-block {\n        position: absolute;\n        box-sizing: border-box;\n        padding-block-start: 0;\n        padding-block-end: 15px;\n        padding-inline-start: 0;\n        padding-inline-end: 6.25%;\n        bottom: 15px;\n        width: 25%;\n      }\n      .footer-container .langue-selection-block .langue-header {\n        color: ").concat(titleFontColor, ";\n        font-weight: 500;\n      }\n\n      .footer-bottom-bar a {\n        line-height: 56px;\n        margin-inline-end: 40px;\n        color: white;\n        text-decoration: none;\n      }\n\n      @media (max-width: 767px) {\n        .footer-container,\n        .footer-bottom-bar {\n          width: 100%;\n          padding: 0;\n          max-width: none;\n        }\n\n        .footer-container .footer-column {\n          padding: 0;\n          width: 100%;\n        }\n\n        .footer-container .footer-column a,\n        .footer-container .footer-column .footer-column-header {\n          margin-top: 0;\n          padding: 10px 40px;\n          width: calc(100% - 80px);\n          line-height: 25px;\n        }\n\n        .footer-container .footer-column .footer-column-header,\n        .footer-container .langue-selection-block {\n          border-top: solid 1px #D4D4D4;\n        }\n\n        .footer-container .footer-column .footer-column-header {\n          cursor: pointer;\n          background-color: ").concat(this.props.backgroundColor, ";\n        }\n\n        .footer-container .footer-column .footer-column-expand-caret {\n          display: block;\n          position: absolute;\n          inset-inline-start: 16px;\n          top: 15px;\n          width: 15px;\n          height: 20px;\n          transform-origin: 55% 45%;\n          cursor: pointer;\n        }\n        .footer-container .footer-column.expanded .footer-column-expand-caret {\n          transform: rotate(90deg);\n          -webkit-transform: rotate(90deg);\n        }\n\n        .footer-container .footer-column a {\n          font-weight: 600;\n          color: ").concat(linkFontColor, ";\n          border-top: solid 1px #E5E5E5;\n          display: none;\n        }\n        .footer-container .footer-column.expanded a {\n          display: block;\n          box-sizing: content-box;\n        }\n\n        .footer-container .langue-selection-block {\n          position: static;\n          width: 100%;\n          height: inherit;\n          top: inherit;\n          padding: 14px 20px 15px;\n        }\n\n        .footer-bottom-bar a {\n          display: block;\n          line-height: 45px;\n          margin-right: 0;\n          padding-inline-start: 20px;\n          border-bottom: solid 1px #D4D4D4;\n        }\n      }\n    ");
      var languageSelectorStyle = {
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        appearance: 'none',
        border: '1px solid #CCCCCC',
        borderRadius: '5px',
        background: 'white',
        width: '100%',
        marginTop: 10,
        padding: '5px 10px',
        fontSize: 14,
        fontFamily: 'inherit',
        color: 'rgba(0, 0, 0, 0.6)',
        height: 34,
        cursor: 'pointer'
      };
      var languageSelectorTriangleStyle = {
        position: 'absolute',
        insetInlineEnd: 10,
        width: 0,
        height: 0,
        pointerEvents: 'none',
        borderStyle: 'solid'
      };
      var triangleBottom = 10;
      var languageSelectorUpTriangleStyle = Object.assign({}, languageSelectorTriangleStyle, {
        bottom: triangleBottom + 8,
        borderWidth: '0 3px 5px 3px',
        borderColor: 'transparent transparent #666666 transparent'
      });
      var languageSelectorDownTriangleStyle = Object.assign({}, languageSelectorTriangleStyle, {
        bottom: triangleBottom,
        borderWidth: '5px 3px 0 3px',
        borderColor: '#666666 transparent transparent transparent'
      });
      var domain = (0, _common.getDomainForURLs)(this.props.domain);
      var gettext = this.createStringSelector();
      var locale = this.getLocale();
      var locSuffix = this.getLocaleUrlSuffixForWWW();
      var snapComUrl = this.props.snapComUrl;
      var localeOptions = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.props.availableLocales[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var avLocale = _step.value;

          if (!_constants.ALL_LOCALES[avLocale]) {
            continue;
          }

          var selected = avLocale === locale;
          localeOptions.push(
          /*#__PURE__*/
          _react["default"].createElement("option", {
            key: avLocale,
            value: avLocale,
            selected: selected
          }, _constants.ALL_LOCALES[avLocale]));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            backgroundColor: this.props.backgroundColor,
            fontSize: 14,
            lineHeight: '17px'
          }
        },
        /*#__PURE__*/
        _react["default"].createElement("style", null, css),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-container",
          id: "footerContainer",
          ref: this.callInitExpandingColumns
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-column"
        }, this.renderColumnHeaderCaret(linkFontColor),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-column-header"
        }, gettext('Company')),
        /*#__PURE__*/
        _react["default"].createElement("div", null,
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale)
        }, gettext('Snap Inc.')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://careers.".concat(snapComUrl)
        }, gettext('Careers')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://newsroom.".concat(snapComUrl)
        }, gettext('News')))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-column"
        }, this.renderColumnHeaderCaret(linkFontColor),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-column-header"
        }, gettext('Community')),
        /*#__PURE__*/
        _react["default"].createElement("div", null,
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://support.".concat(domain, "/")
        }, gettext('Support')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale, "/community-guidelines")
        }, gettext('Community Guidelines')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale, "/safety/safety-center")
        }, gettext('Safety Center')))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-column"
        }, this.renderColumnHeaderCaret(linkFontColor),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-column-header"
        }, gettext('Advertising')),
        /*#__PURE__*/
        _react["default"].createElement("div", null,
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(domain, "/").concat(locSuffix, "ads")
        }, gettext('Buy Ads')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale, "/ad-policies/")
        }, gettext('Advertising Policies')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale, "/political-ads/")
        }, gettext('Political Ads Library')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale, "/brand-guidelines/")
        }, gettext('Brand Guidelines')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://support.".concat(domain, "/a/promotions-rules")
        }, gettext('Promotions Rules')))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-column"
        }, this.renderColumnHeaderCaret(linkFontColor),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-column-header"
        }, gettext('Legal')),
        /*#__PURE__*/
        _react["default"].createElement("div", null,
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale, "/privacy/privacy-center/")
        }, gettext('Privacy Center')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://help.snapchat.com/hc/articles/11399265637012?utm_source=snapchat_com&utm_medium=global_footer&utm_campaign=privacy_choices"
        }, gettext('Your Privacy Choices')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale, "/cookie-policy/")
        }, gettext('Cookie Policy')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://support.".concat(domain, "/article/infringement-reporting-about")
        }, gettext('Report Infringement')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale, "/terms/custom-creative-tools/")
        }, gettext('CUSTOM_CREATIVE_TOOLS_TOS')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(domain, "/create/terms.html")
        }, gettext('COMMUNITY_TOS')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://".concat(snapComUrl, "/").concat(locale, "/terms/lens-studio-license-agreement")
        }, gettext('LENS_STUDIO_TOS')))),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            clear: 'both'
          }
        }), localeOptions.length > 1 ?
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "langue-selection-block"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "langue-header"
        }, gettext('Language')),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            position: 'relative'
          }
        },
        /*#__PURE__*/
        _react["default"].createElement("select", {
          id: "sc-global-locale-selector",
          onChange: this.localeSelected,
          style: languageSelectorStyle
        }, localeOptions),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: languageSelectorUpTriangleStyle
        }),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: languageSelectorDownTriangleStyle
        }))) : null),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            backgroundColor: '#262626'
          }
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "footer-bottom-bar"
        },
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: this.props.privacyPolicyUrlOverride || "https://".concat(snapComUrl, "/").concat(locale, "/privacy/privacy-policy/")
        }, gettext('Privacy Policy')),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: this.props.termsOfServiceUrlOverride || "https://".concat(snapComUrl, "/").concat(locale, "/terms/")
        }, gettext('Terms of Service')), this.props.showImpressum &&
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: "https://support.snapchat.com/a/impressum",
          className: "impressum"
        }, gettext('Impressum')),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            clear: 'both'
          }
        }))), this.props.disableCookiePopup ? null :
        /*#__PURE__*/
        _react["default"].createElement(_cookiePopup["default"], {
          leftCookieIconSrc: "https://www.".concat(domain, "/home/cookie-1.svg"),
          rightCookieIconSrc: "https://www.".concat(domain, "/home/cookie-2.svg"),
          cookiePolicyUrl: "https://www.".concat(snapComUrl, "/cookie-policy/"),
          cookieSettingsUrl: "https://www.".concat(domain, "/cookie-settings"),
          locale: locale,
          domain: domain,
          theme: this.props.cookiePopupTheme
        }))
      );
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {}
  }]);

  return SnapchatFooter;
}(_frameComponent["default"]);

exports["default"] = SnapchatFooter;

_defineProperty(SnapchatFooter, "propTypes", {
  domain: _propTypes["default"].string,
  cookieDomain: _propTypes["default"].string,
  snapComUrl: _propTypes["default"].string,
  locale: _propTypes["default"].string,
  availableLocales: _propTypes["default"].array,
  onLocaleSelected: _propTypes["default"].func,
  disableCookiePopup: _propTypes["default"].bool,
  termsOfServiceUrlOverride: _propTypes["default"].string,
  privacyPolicyUrlOverride: _propTypes["default"].string,
  showImpressum: _propTypes["default"].bool,
  backgroundColor: _propTypes["default"].string,
  cookiePopupTheme: _propTypes["default"].oneOf(Object.keys(_cookiePopupThemes["default"]))
});

_defineProperty(SnapchatFooter, "defaultProps", {
  domain: _constants.DEFAULT_DOMAIN,
  cookieDomain: '',
  snapComUrl: _constants.DEFAULT_SNAP_COM_DOMAIN,
  locale: null,
  availableLocales: _constants.DEFAULT_AVAILABLE_LOCALES,
  onLocaleSelected: null,
  disableCookiePopup: false,
  termsOfServiceUrlOverride: null,
  privacyPolicyUrlOverride: null,
  showImpressum: false,
  backgroundColor: '#F8F9FB',
  cookiePopupTheme: 'Light'
});